// extracted by mini-css-extract-plugin
export default {"wrap":"SingleEventPage_wrap__Xi610","content":"SingleEventPage_content__OWgaM","sidebar":"SingleEventPage_sidebar__SYkYL"};